import React from 'react';
import InputPassword from './InputPassword';
import Fieldset from './Fieldset';

export interface FieldsetPasswordProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  htmlFor: string;
  label?: string;
  fieldsetClassName?: string;
  hint?: string;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
}

const FieldsetPassword = React.forwardRef<HTMLInputElement, FieldsetPasswordProps>(
  (
    { id, htmlFor, label, hint, hintClassName, hintId, hintHidden, fieldsetClassName, ...props },
    ref
  ) => {
    return (
      <Fieldset
        id={id}
        htmlFor={htmlFor}
        label={label}
        hint={hint}
        hintClassName={hintClassName}
        hintId={hintId}
        hintHidden={hintHidden}
        fieldsetClassName={fieldsetClassName}
        {...props}
        ref={ref}
      >
        <InputPassword
          id={id}
          label={label}
          hint={hint}
          hintClassName={hintClassName}
          hintId={hintId}
          hintHidden={hintHidden}
          {...props}
        />
      </Fieldset>
    );
  }
);

FieldsetPassword.displayName = 'FieldsetPassword';

export default FieldsetPassword;
